import { ReactNodeView, TCreateReactNodeView } from '../ReactNodeView/ReactNodeView'

import Styles from './Iframe.module.scss'

export class IframeNodeView extends ReactNodeView {
  ignoreMutation = () => true
  selectNode = () => {
    this.rerender()
  }
  deselectNode = () => {
    this.rerender()
  }

  stopEvent: ((event: Event) => boolean) | null = (e) => {
    if (e.target) {
      if ((e.target as HTMLElement).classList.contains(Styles.resizeHandle)) {
        e.preventDefault()

        return true
      }
    }

    if (e.type.includes('drag')) return false

    // if (this.selected) return true

    return false
  }
}

export const createIframeNodeView = ({
  node,
  view,
  getPos,
  decorations,
  component,
  onCreatePortal,
  onDestroyPortal,
  inCommentMode,
}: TCreateReactNodeView) => {
  const reactNodeView = new IframeNodeView(node, view, getPos, decorations, component, onDestroyPortal, !!inCommentMode)
  const { nodeView, portal } = reactNodeView.init()
  onCreatePortal(portal)

  return nodeView
}
